module.exports = __webpack_public_path__ + "img/esigne2.191e52e7.png";